import { Translatable } from '@app/types/translatable.type';

type TranslatableKeys = { [key: string]: Translatable };

export const TypesTooltips: TranslatableKeys = {
    typeName: 'time-off-v3.tips.types.name',
    color: 'time-off-v3.tips.types.color',
    visibility: 'time-off-v3.tips.types.visibility',
    trackTime: 'time-off-v3.tips.types.trackTime',
    paidTimeSettings: 'time-off-v3.tips.types.paidTimeSettings',
    description: 'time-off-v3.tips.types.description',
} as const;

export const PolicyFormTooltips: TranslatableKeys = {
    policyName: 'time-off-v3.tips.policy.name',
    accrualSetting: 'time-off-v3.tips.policy.accrualSetting',
    accrualFrequency: 'time-off-v3.tips.policy.accrualFrequency',
    approvalFlow: 'time-off-v3.tips.policy.approvalFlow',
} as const;

export const AdvancedFormTooltips: TranslatableKeys = {
    seniorityOverrides: 'time-off-v3.tips.advanced-policy-settings.seniorityOverrides',
    proratesFirstAccrual: 'time-off-v3.tips.advanced-policy-settings.proratesFirstAccrual',
    yearEndBalanceCap: 'time-off-v3.tips.advanced-policy-settings.yearEndBalanceCap',
    maxBalanceCap: 'time-off-v3.tips.advanced-policy-settings.maxBalanceCap',
    allowNegativeBalanceCap: 'time-off-v3.tips.advanced-policy-settings.allowNegativeBalanceCap',
    waitingPeriod: 'time-off-v3.tips.advanced-policy-settings.waitingPeriod',
    limitRequestLength: 'time-off-v3.tips.advanced-policy-settings.limitRequestLength',
} as const;

export const SettingsToolTips: TranslatableKeys = {
    timeOffLeaveVisibility: 'time-off-v3.tips.settings.timeOffLeaveVisibility',
    timeOffBalanceDate: 'time-off-v3.tips.settings.timeOffBalanceDate',
} as const;
